// router/index.js
import Vue from 'vue';
import Router from 'vue-router';
import index from '@/components/index.vue';
import afterSalesDetails from '@/components/afterSalesDetails.vue';
import afterSalesList from '@/components/afterSalesList.vue';
import login from '@/components/login.vue';
import apply from '@/components/apply.vue';
import auth from '@/components/auth.vue';
import cart from '@/components/cart.vue';
import carAddress from '@/components/carAddress.vue';
import credit from '@/components/credit.vue';
import goodsDetails from '@/components/goodsDetails.vue';
import goodsList from '@/components/goodsList.vue';
import myShop from '@/components/myShop.vue';
import notice from '@/components/notice.vue';
import orderDetails from '@/components/orderDetails.vue';
import orderList from '@/components/orderList.vue';
import register from '@/components/register.vue';
import user from '@/components/user.vue';
Vue.use(Router);

// export default new Router({
// 	mode: 'history', // 使用 history 模式
// 	routes: [{
// 			path: '/',
// 			name: 'index',
// 			component: index,
// 		},
// 		{
// 			path: '/afterSalesDetails',
// 			name: '售后订单详情',
// 			component: afterSalesDetails,
// 		}, {
// 			path: '/afterSalesList',
// 			name: '售后订单',
// 			component: afterSalesList,
// 		}, {
// 			path: '/login',
// 			name: '登录',
// 			component: login,
// 		},
// 		{
// 			path: '/apply',
// 			name: '申请售后',
// 			component: apply,
// 		}, {
// 			path: '/auth',
// 			name: '认证',
// 			component: auth,
// 		}, {
// 			path: '/car',
// 			name: '购物车',
// 			component: car,
// 		}, {
// 			path: '/carAddress',
// 			name: '购物车',
// 			component: carAddress,
// 		}, {
// 			path: '/credit',
// 			name: '授信',
// 			component: credit,
// 		}, {
// 			path: '/goodsList',
// 			name: '商品列表',
// 			component: goodsList,
// 		}, {
// 			path: '/goodsDetails',
// 			name: '详情',
// 			component: goodsDetails,
// 		}, {
// 			path: '/myShop',
// 			name: '我的店铺',
// 			component: myShop,
// 		}, {
// 			path: '/notice',
// 			name: '消息公告',
// 			component: notice,
// 		}, {
// 			path: '/orderList',
// 			name: '我的订单',
// 			component: orderList,
// 		}, {
// 			path: '/orderDetails',
// 			name: '订单详情',
// 			component: orderDetails,
// 		}, {
// 			path: '/register',
// 			name: '注册',
// 			component: register,
// 		}, {
// 			path: '/user',
// 			name: '个人中心',
// 			component: user,
// 		}

// 	],
// });

const router = new Router({
	mode: 'history', // 使用 history 模式
	routes: [{
			path: '/',
			name: 'index',
			component: index,
		},
		{
			path: '/afterSalesDetails',
			name: '售后订单详情',
			component: afterSalesDetails,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/afterSalesList',
			name: '售后订单',
			component: afterSalesList,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/login',
			name: '登录',
			component: login,
		},
		{
			path: '/apply',
			name: '申请售后',
			component: apply,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/auth',
			name: '认证',
			component: auth,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/cart',
			name: '购物车',
			component: cart,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/carAddress',
			name: '购物车下单',
			component: carAddress,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/credit',
			name: '授信',
			component: credit,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/goodsList',
			name: '商品列表',
			component: goodsList,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/goodsDetails',
			name: '详情',
			component: goodsDetails,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/myShop',
			name: '我的店铺',
			component: myShop,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/notice',
			name: '消息公告',
			component: notice,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/orderList',
			name: '我的订单',
			component: orderList,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/orderDetails',
			name: '订单详情',
			component: orderDetails,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}, {
			path: '/register',
			name: '注册',
			component: register,
		}, {
			path: '/user',
			name: '个人中心',
			component: user,
			meta: {
				requiresAuth: true
			} // 需要身份验证的路由
		}
	]
});

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
	const token = localStorage.getItem('token'); // 假设你将token存储在localStorage中
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// 此路由需要授权，请检查是否已登录
		// 如果没有登录，则重定向至登录页面
		if (!token) {
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				} // 将用户尝试访问的路径作为参数传递给登录页
			});
		} else {
			next(); // 已登录，允许进入该路由
		}
	} else {
		next(); // 确保一定要调用 next()
	}
});

export default router;